
var serverActions = {
  generateClientPasswordResetToken: 'generate_client_password_recovery_token',
  resetClientPassword: 'reset_client_password'
};

var serverConnectorService;
var q;
var instance;


class PasswordResetService {
    constructor($q, ServerConnectorService) {
      instance = this;
      q = $q;
      serverConnectorService = ServerConnectorService;
    }
    
    generateClientPasswordResetToken(email){
      var deferred = q.defer();
      var ws = serverConnectorService.connect();
      var request = {
        action_name : serverActions.generateClientPasswordResetToken,
        email : email
      }
      serverConnectorService.send(request, ws, deferred);
      return deferred.promise;
    }

    resetClientPassword(email, token, newPassword){
      var deferred = q.defer();
      var ws = serverConnectorService.connect();
      var request = {
        action_name: serverActions.resetClientPassword,
        email:  email,
        token: token,
        new_password: newPassword
      }
      serverConnectorService.send(request, ws, deferred);
      return deferred.promise;
    }


    static factory($q, ServerConnectorService){
      return new PasswordResetService($q, ServerConnectorService);
    }
}

PasswordResetService.factory.$inject = ['$q', 'ServerConnectorService'];

export default PasswordResetService = PasswordResetService.factory;


// WEBPACK FOOTER //
// ./src/service/server-connector/password-reset.service.js